// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PopularLocationGridItem-GridWrap-eBwqw {
  display: block;
  overflow: hidden;
  -webkit-transform: scale(1);
      -ms-transform: scale(1);
          transform: scale(1);
  -webkit-transition: .5s all ease-in-out;
  transition: .5s all ease-in-out;
  -webkit-transition: .5s all ease;
  -moz-transition: .5s all ease;
  -o-transition: .5s all ease;
  background-color: var(--secondary-gray-bg);
}

.PopularLocationGridItem-GridColZoom-Ertsv {
  overflow: hidden;
  display: block;
  position: relative;
  border-radius: 5px;
}

.PopularLocationGridItem-placeWrap-Q7Dl7 {
  font-size: 18px;
  text-align: center;
  padding: 25px 12px 0;
  color: var(--primary-foreground);
  font-weight: 600;
}

.PopularLocationGridItem-GridCol-OoqEk {
  width: 25%;
  padding: 5px;
}

.PopularLocationGridItem-GridWrap-eBwqw {
  width: 100%;
  min-height: 279px;
  background-size: cover;
  background-position: top center;
  backface-visibility: hidden;
  -webkit-backface-visibility: hidden;
  -webkit-box-shadow: 0px 3px 6px var(--primary-box-shadow);
          box-shadow: 0px 3px 6px var(--primary-box-shadow);
  border-radius: 20px;
}

.PopularLocationGridItem-GridCol-OoqEk:nth-child(2) {
  width: 25%;
  clear: both;
}

.PopularLocationGridItem-GridCol-OoqEk:nth-child(3) {
  position: absolute;
  width: 50%;
  top: 0;
  left: 25%;
}

.PopularLocationGridItem-GridCol-OoqEk:nth-child(3) .PopularLocationGridItem-GridColZoom-Ertsv .PopularLocationGridItem-GridWrap-eBwqw {
  width: 100%;
  height: 330px;
  background-size: cover;
  background-position: top center;
}

.PopularLocationGridItem-GridCol-OoqEk:nth-child(4) {
  position: absolute;
  width: 25%;
  top: 0;
  right: 0;
}

.PopularLocationGridItem-GridCol-OoqEk:nth-child(5) {
  position: absolute;
  width: 25%;
  top: 170px;
  right: 0;
}

.PopularLocationGridItem-GridCol-OoqEk:nth-child(6) {
  width: 25%;
  clear: both;
}

.PopularLocationGridItem-noPadding-YaQKf {
  padding: 0 15px 0 0;
}

@media (max-width:767px) {
  .PopularLocationGridItem-GridCol-OoqEk {
    width: 100% !important;
    height: auto !important;
    position: static !important;
  }

  .PopularLocationGridItem-GridCol-OoqEk {
    padding: 5px 0px;
  }

  .PopularLocationGridItem-placeWrap-Q7Dl7 {
    padding: 20px;
  }

  .PopularLocationGridItem-noPadding-YaQKf {
    padding: 0;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Home/PopularLocationGridItem/PopularLocationGridItem.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,gBAAgB;EAChB,2BAAmB;MAAnB,uBAAmB;UAAnB,mBAAmB;EACnB,uCAA+B;EAA/B,+BAA+B;EAC/B,gCAAgC;EAChC,6BAA6B;EAC7B,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,oBAAoB;EACpB,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,YAAY;AACd;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,sBAAsB;EACtB,+BAA+B;EAC/B,2BAA2B;EAC3B,mCAAmC;EACnC,yDAAiD;UAAjD,iDAAiD;EACjD,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,MAAM;EACN,SAAS;AACX;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,MAAM;EACN,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,QAAQ;AACV;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,sBAAsB;IACtB,uBAAuB;IACvB,2BAA2B;EAC7B;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,UAAU;EACZ;AACF","sourcesContent":[".GridWrap {\n  display: block;\n  overflow: hidden;\n  transform: scale(1);\n  transition: .5s all ease-in-out;\n  -webkit-transition: .5s all ease;\n  -moz-transition: .5s all ease;\n  -o-transition: .5s all ease;\n  background-color: var(--secondary-gray-bg);\n}\n\n.GridColZoom {\n  overflow: hidden;\n  display: block;\n  position: relative;\n  border-radius: 5px;\n}\n\n.placeWrap {\n  font-size: 18px;\n  text-align: center;\n  padding: 25px 12px 0;\n  color: var(--primary-foreground);\n  font-weight: 600;\n}\n\n.GridCol {\n  width: 25%;\n  padding: 5px;\n}\n\n.GridWrap {\n  width: 100%;\n  min-height: 279px;\n  background-size: cover;\n  background-position: top center;\n  backface-visibility: hidden;\n  -webkit-backface-visibility: hidden;\n  box-shadow: 0px 3px 6px var(--primary-box-shadow);\n  border-radius: 20px;\n}\n\n.GridCol:nth-child(2) {\n  width: 25%;\n  clear: both;\n}\n\n.GridCol:nth-child(3) {\n  position: absolute;\n  width: 50%;\n  top: 0;\n  left: 25%;\n}\n\n.GridCol:nth-child(3) .GridColZoom .GridWrap {\n  width: 100%;\n  height: 330px;\n  background-size: cover;\n  background-position: top center;\n}\n\n.GridCol:nth-child(4) {\n  position: absolute;\n  width: 25%;\n  top: 0;\n  right: 0;\n}\n\n.GridCol:nth-child(5) {\n  position: absolute;\n  width: 25%;\n  top: 170px;\n  right: 0;\n}\n\n.GridCol:nth-child(6) {\n  width: 25%;\n  clear: both;\n}\n\n.noPadding {\n  padding: 0 15px 0 0;\n}\n\n@media (max-width:767px) {\n  .GridCol {\n    width: 100% !important;\n    height: auto !important;\n    position: static !important;\n  }\n\n  .GridCol {\n    padding: 5px 0px;\n  }\n\n  .placeWrap {\n    padding: 20px;\n  }\n\n  .noPadding {\n    padding: 0;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"GridWrap": `PopularLocationGridItem-GridWrap-eBwqw`,
	"GridColZoom": `PopularLocationGridItem-GridColZoom-Ertsv`,
	"placeWrap": `PopularLocationGridItem-placeWrap-Q7Dl7`,
	"GridCol": `PopularLocationGridItem-GridCol-OoqEk`,
	"noPadding": `PopularLocationGridItem-noPadding-YaQKf`
};
module.exports = ___CSS_LOADER_EXPORT___;
